





































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { apiProvider } from './api';
import { showAlert } from '@/main/utils/notifications';

import { NAME } from './constants';
import { editActions } from './store/types';
import { store } from './store/edit';


type NdSkladFilter = {
	VyrobekndOzn: string | null;
	NdNr: string | null;
	SkladOzn: number | null;
	NdText: string | null;
	EanCode: string | null;
};

export default editFactory(NAME, store).extend({
	components: {
		NdSkladSelectWithCheck: NdSklad.components.SelectWithCheck,
	},
	data() {
		return {
			defaultquantity: 0,
			returnquantity: 0,
		};
	},
	watch: {
		Mnozstvi(newValue) {
			if (this.ncCelkPrpCmp) {
				this.Nc = (this.ncCelkCmp ?? 0) / (newValue || 1);
			} else {
				this.ncCelkCmp = (this.Nc ?? 0) * (newValue ?? 0);
			}
		},
	},
	computed: {
		actionsMapper(): Record<string, string> {
			return {
				ndPolozky: `${this.storeUri}/${editActions.ND_SKLAD_POLOZKY_MAPPER}`,
			};
		},
		ncCelkKorCmp: {
			get(): number | null {
				return this.NcCelkKor;
			},
			set(newValue: number) {
				this.NcKor = newValue;
				this.NcCelkKor = newValue;
			},
		},
		ndskladFilter(): NdSkladFilter {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				SkladOzn: this.SkladOzn,
				NdText: this.Text,
				EanCode: this.eanKlic,
			};
		},
		isUzavreno(): boolean {
			return false;
		},
		ncCmp: {
			get(): number | null {
				return this.Nc;
			},
			set(newValue: number) {
				this.Nc = newValue;
				if (!this.ncCelkPrpCmp) {
					this.NcCelk = (newValue ?? 0) / (this.Mnozstvi || 1);
				}
			},
		},
		ncCelkCmp: {
			get(): number | null {
				return this.NcCelk;
			},
			set(newValue: number) {
				this.NcCelk = newValue;
				if (this.ncCelkPrpCmp) {
					this.Nc = (newValue ?? 0) / (this.Mnozstvi || 1);
				}
			},
		},
		ncCelkPrpCmp(): boolean {
			return _.isNil(this.props.ncCelkPrpActual) ? !!this.NcCelkPrp : !!this.props.ncCelkPrpActual;
		},
	},
	methods: {
		async loadedData() {
			this.isCreateMode && (this.SkladOzn = this.props.skladOzn!);
			this.defaultquantity = this.Mnozstvi ?? 0;
			this.startLoading();
			try {
				const availablequantity = await apiProvider.checkAvailableQuantity(this.NdPrijemId!, this.NdNr!);
				this.returnquantity = Math.max(Number(availablequantity.data ?? 0) - this.defaultquantity, 0);
			} finally {
				this.endLoading();
			}
		},
		cPCalculation() {
			this.ncCmp = (this.ncCelkCmp ?? 0) / (this.Mnozstvi || 1);
			this.Nc = (this.ncCelkCmp ?? 0) / (this.Mnozstvi || 1);
			this.ncCelkCmp = (this.Nc ?? 0) * (this.Mnozstvi ?? 0);
		},
		async customValidation() {
			if (this.Mnozstvi! <= 0) {
				this.showErrorNotification(this.LocalizeChyboveHlasky('NDPrijemErrMnozstvi'));
				return false;
			}
			if (this.skladKartaPnc && this.Pc! < this.skladKartaPnc!) {
				if (!await this.showConfirmPokracovat('NDPrijemPCNC')) {
					return false;
				}
			}
			const nc = this.isUzavreno ? this.KorNc : this.Nc;
			if (this.PcNdsklad && this.Pc! < nc!) {
				if (!await this.showConfirmPokracovat('NDPrijemPCNC2', true, true)) {
					return false;
				}
			}
			if (this.loggedUser.DmsSys.PROrdersPrp) {
				if (this.PartReturnCount !== null && this.Mnozstvi !== null && this.Mnozstvi > this.PartReturnCount) {
					showAlert({
						message: this.LocalizeChyboveHlasky('prReturnCount'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return false;
				}
				if (this.ncCmp !== null && this.Pc !== null && this.ncCmp <= 0 && this.Pc <= 0) {
					showAlert({
						message: this.LocalizeChyboveHlasky('validateCPSP'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return false;
				}

				this.startLoading();
				let alreadyReturnedWithoutCurrent = 0;
				try {
					const availablequantity = await apiProvider.checkAvailableQuantity(this.NdPrijemId!, this.NdNr!);
					alreadyReturnedWithoutCurrent = Math.max(Number(availablequantity.data ?? 0) - this.defaultquantity, 0);
				} finally {
					this.endLoading();
				}
				const requestedQuantity = this.Mnozstvi ?? 0;
				const ndPrijemPartQuantity = this.PartReturnCount ?? 0;
				const maxAllowedQuantity = Math.max(ndPrijemPartQuantity - alreadyReturnedWithoutCurrent, 0);
				if (requestedQuantity > maxAllowedQuantity) {
					showAlert({
						message: this.LocalizeChyboveHlasky('prReturnCount'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					this.Mnozstvi = this.defaultquantity;
					return false;
				}
			}
			return true;
		},
		async existSkladovaKarta() {
			this.startLoading();
			const { data: skladExists } = await NdSklad.apiProvider.getNdSklad({
				vyrobekndOzn: this.VyrobekndOzn!,
				ndNr: this.NdNr!,
				skladOzn: this.SkladOzn!,
			});
			this.endLoading();
			if (!skladExists) {
				const newPartAdditionconfirmation = await this.showConfirm({ message: this.LocalizeChyboveHlasky('DoAddND') });
				if (newPartAdditionconfirmation) {
					await openEdit(NdSklad.name, PageMode.CREATE, {
						filter: {
							SkladOzn: this.SkladOzn,
							VyrobekndOzn: this.VyrobekndOzn,
							NdNr: this.NdNr,
							Text: this.Text,
							EanCode: this.EanCode,
						},
					});
				}
				return false;
			}
			return true;
		},
		refreshFun() {
			this.$nextTick(() => {
				(this.$refs.ndSkladSelect as (Vue & { onCheckClick(): void })).onCheckClick();
			});
		},
	},
});
